import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { StyledEngineProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import loader from '../../../assets/Images/loader.gif';
 
const BusinessMeetingsHotel = () => {

  const style = {
        control: (base) => ({
            ...base,
            border: 0,
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
        inputFocused: {
            boxShadow: "none",
            fontSize: "14px",
        },
    };
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [mode, setMode] = useState(null);
  const [remarks, setRemarks] = useState('');
  const [status, setStatus] = useState(null);
  const [met, setMet] = useState(null);
  const [getMeetingData, setMeetingData] = useState([]);
  const [position, setPosition] = useState({ latitude: null, longitude: null });
  const [loading, setLoading] = useState(false);
  const [isDateTimeLocked, setIsDateTimeLocked] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const OppId = searchParams.get('OppId');
  const leadId = searchParams.get('LeadId');
  const ContactId = searchParams.get('ContactId');
 
  const modeOptions = [
    { value: '0', label: 'Virtual' },
    { value: '1', label: 'In-Person' },
  ];
  const statusOptions = [
    { value: '0', label: 'Open' },
    { value: '1', label: 'Completed' },
    { value: '2', label: 'Cancelled' },
  ];
  const metOptions = [
    { value: '9', label: 'General Manager' },
    { value: '10', label: 'Owner/Director' },
    { value: '11', label: 'Sales' },
    { value: '12', label: 'IT' },
    { value: '13', label: 'Procurement' },
    { value: '3', label: 'Unavailable' },
  ];
 
  
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getLeads",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    ContactId: ContactId ? ContactId : "",
                    LeadId: leadId ? leadId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName')
                }
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                const data = await response.json();
                // console.log("getLeads", data);

                if (data.Status == "Success") {
                    // console.log("getLeads", data);

                    if (data.Response[0]?.Status == 1 || data.Response[0]?.Status == 2) {
                        toast.warning("Cannot Create meeting as Lead is already Qualified/Disqualified", {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 2000,
                        });
                        navigate("/businessLeadHotel");
                    }

                }

            } catch (error) {
                //console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

    }, [leadId]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });

                const responsedata = await response.json();
                const responseData = responsedata?.Response?.Data?.[0];
                // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

                // console.log("getLeads1" ,responsedata1);
                if (responsedata?.Status === "Success" && responseData) {
                    // console.log("responsedata", responseData.Status);

                    if (responseData.Status !== "Open") {
                        toast.warning("Cannot Create meeting as Opportunity is already Won/Lost", {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 2000,
                        });
                        navigate("/businessOpportunityHotel");
                    }


                } else {
                    console.error("Error fetching opportunity data:", responseData?.Message);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getContactIndustry",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    contactID: ContactId,
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                const data = await response.json();
                // const data = await response.json();
                const apiData = data.Response.Data[0];

                // console.log(apiData);

                if (apiData.StatusReason == "Lead Created/Closed" || apiData.StatusReason == "Disqualified") {
                    toast.warning("Cannot Create meeting as Contact is already Qualified/Disqualified", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    navigate("/businessContactHotel");
                }


            } catch (error) {
                //console.error("Error fetching data:", error);
                toast.warning(error, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 500,
                });

            } finally {

            }
        };
        fetchData();
    }, [ContactId]);


  const getLocation = () => {
    if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
      toast.error('Location access requires HTTPS. Please use a secure connection.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
      });
      return;
    }
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        pos => setPosition({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
        () =>
          toast.error('Unable to retrieve location. Check permissions.', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
          })
      );
    } else {
      toast.warning('Geolocation is not supported by this browser.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
      });
    }
  };
 
  useEffect(() => {
    getLocation();
  }, []);
 
  useEffect(() => {
    const fetchMeetingData = async () => {
      setLoading(true);
      try {
        const response = await fetch(process.env.REACT_APP_API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
            Action: 'getMeeting',
            ContactID: ContactId,
            LeadID: leadId,
            OppId: OppId,
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName'),
          }),
        });
        const { Status, Response } = await response.json();
        if (Status === 'Success' && Response?.Data) {
          const data = Response.Data;
          setMeetingData(data);
          const openMeeting = data.find(item => item.MeetingStatus === 'Open');
          if (openMeeting) {
            setSelectedDateTime(dayjs(openMeeting.MeetingDateandTime));
            if (openMeeting.MeetingEndDateandTime) {
              const [date, time] = openMeeting.MeetingEndDateandTime.split(' ');
              setEndTime(dayjs(`${date}T${time}`));
            }
            setMode(modeOptions.find(o => o.label === openMeeting.MeetingMode));
            setStatus(statusOptions.find(o => o.label === openMeeting.MeetingStatus));
            setMet(metOptions.find(o => o.label === openMeeting.MetWithWhom));
            setRemarks(openMeeting.Remarks);
            setIsDateTimeLocked(true);
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchMeetingData();
  }, [ContactId, leadId, OppId]);
 
  const hasOpenMeeting = getMeetingData.some(m => m.MeetingStatus === 'Open');
  const filteredStatus = hasOpenMeeting
    ? statusOptions.filter(o => o.value !== '0')
    : statusOptions.filter(o => o.value === '0');
 
  const composePayload = () => {
    const start = selectedDateTime.format('YYYY-MM-DD HH:mm:ss');
    const end = endTime
      ? `${selectedDateTime.format('YYYY-MM-DD')} ${endTime.format('HH:mm:ss')}`
      : start;
    return {
      Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
      Action: hasOpenMeeting ? 'updateMeeting' : 'addMeeting',
      ContactID: ContactId,
      LeadID: leadId,
      OppId: OppId,
      DateTime: start,
      MeetingEndDateandTime: end,
      Mode: mode?.value || '',
      Remarks: remarks,
      status: status?.value || '',
      metWithWhom: met?.value || '',
      Latitude: position.latitude || '',
      Longitude: position.longitude || '',
      password: sessionStorage.getItem('password'),
      userName: sessionStorage.getItem('userName'),
    };
  };
 
  const handleSave = async () => {
    setLoading(true);
    getLocation();
    try {
      const resp = await fetch(process.env.REACT_APP_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(composePayload()),
      });
      { console.log("composePayload", composePayload) }
 
      const result = await resp.json();
      if (result.Status === 'Success') {
        toast.success(
          hasOpenMeeting ? 'Meeting Updated Successfully' : 'Meeting Created Successfully',
          { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
        );
        if (OppId) navigate('/businessOpportunityHotel');
        else if (leadId) navigate('/businessLeadHotel');
        else if (ContactId) navigate('/businessContactHotel');
      } else {
        toast.warning(result.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            style={{ cursor: 'pointer' }}
           onClick={() => {
              if (OppId) navigate('/businessOpportunityHotel');
              else if (leadId) navigate('/businessLeadHotel');
              else if (ContactId) navigate('/businessContactHotel');
            }}
          >
            <i className="fa-solid fa-arrow-left-long" />
          </span>
          <span className="p-1 m-3">Schedule Appointment</span>
        </div>
      </div>

      <div className="container-fluid form-container">
        {loading ? (
          <div className="loader-wrapper">
            <div className="loader">
              <img src={loader} alt="loading..." />
            </div>
          </div>
        ) : (
          <>
            <div className="container shadow mb-3 bg-body rounded mt-4">
              <form className="p-2 contact-form">
                <div className='clock-style'>
                  <label className="select-search-label mt-1">Date and Time*</label>
                  <StyledEngineProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                      <MobileDateTimePicker
                        value={selectedDateTime}
                        onAccept={dt => {
                          const now = dayjs();
                          if (dt.isSame(now, 'day') && dt.isBefore(now)) {
                            toast.warning('Please pick a time later than right now.', {
                              position: toast.POSITION.BOTTOM_CENTER,
                              autoClose: 1500,
                            });
                            setSelectedDateTime(now);
                          } else if (!isDateTimeLocked) {
                            setSelectedDateTime(dt);
                            getLocation();
                          }
                        }}
                        disablePast
                        minDateTime={dayjs()}
                        disabled={isDateTimeLocked}
                        ampm
                        inputFormat="DD/MM/YYYY hh:mm A"
                        mask=""
                        renderInput={params => (
                          <TextField
                            {...params}
                            InputProps={params.InputProps}
                            inputProps={{
                              ...params.inputProps,
                              placeholder: '', // <- 🔥 This is the key
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </StyledEngineProvider>
                  
                </div>

                <div className="clock-style mt-3">
                  <label className="select-search-label mt-1">End Time*</label>
                  <StyledEngineProvider>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="en"
                    >
                      <MobileTimePicker
                        value={endTime}
                        onAccept={t => {
                          const min = selectedDateTime || dayjs();
                          if (t.isBefore(min)) {
                            toast.warning('Please pick an end time after the start time.', {
                              position: toast.POSITION.BOTTOM_CENTER,
                              autoClose: 1500,
                            });
                            setEndTime(min);
                          } else if (!isDateTimeLocked) {
                            setEndTime(t);
                          }
                        }}
                        disabled={isDateTimeLocked}
                        minTime={selectedDateTime || dayjs()}
                        ampm
                        ampmInClock
                        inputFormat="hh:mm A"
                        mask=""
                        renderInput={params => (
                          <TextField
                            {...params}
                            InputProps={params.InputProps}
                            inputProps={{
                              ...params.inputProps,
                              placeholder: '', // <- 🔥 This is the key
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </StyledEngineProvider>
                </div>

                <div className="search-building mt-3" style={{ position: 'relative' }}>
                  <label className="select-search-label mt-1">Mode*</label>
                  <Select 
                  className="basic-single form-control form-control-sm  p-1 "
                  options={modeOptions} 
                  styles={style}
                  value={mode} 
                  onChange={setMode} 
                  isSearchable={false} />
                </div>

                <div className="search-building mt-3" style={{ position: 'relative' }}>
                  <label className="select-search-label mt-1">Status*</label>
                  <Select
                   className="basic-single form-control form-control-sm  p-1 "
                    styles={style}
                    options={filteredStatus}
                    value={status}
                    onChange={setStatus}
                    isSearchable={false}
                  />
                </div>

                <div className="search-building mt-3" style={{ position: 'relative' }}>
                  <label className="select-search-label mt-1">Person Met*</label>
                  <Select
                   className="basic-single form-control form-control-sm  p-1 "
                   styles={style}
                   options={metOptions} value={met} onChange={setMet} isSearchable={false} />
                </div>

                <div className="input-box form-floating mb-3 mt-3">
                  <textarea
                    styles={style}
                    id="remarks"
                    className="form-control input-text"
                    value={remarks}
                    onChange={e => setRemarks(e.target.value)}
                    rows="3"
                    placeholder="Enter remarks"
                  />
                  <label htmlFor="remarks">Remarks</label>
                </div>

                <div className="text-center mt-5 mb-5">
                  <button
                    type="button"
                    className="btn text-light bg-dark rounded-pill submit-btn"
                    onClick={handleSave}
                  >
                    {hasOpenMeeting ? 'Update' : 'Save'}
                  </button>
                </div>
              </form>
            </div>

            <div className="container shadow bg-body rounded mt-4 p-4">
              <h5>Meeting History</h5>
              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                {getMeetingData.length > 0 ? (
                  getMeetingData.map((data, idx) => (
                    <div className="col" key={idx}>
                      <div className="card mb-3">
                        <div className="m-2 card-data">
                          <p className="opportunity-card-title">
                            Schedule: {data.MeetingDateandTime}
                          </p>
                          <p className="opportunity-card-text">
                            End: {data.MeetingEndDateandTime}
                          </p>
                          <p className="opportunity-card-text">Mode: {data.MeetingMode}</p>
                          <p className="opportunity-card-text">
                            Status: {data.MeetingStatus}
                          </p>
                          <p className="opportunity-card-text">
                            Met: {data.MetWithWhom}
                          </p>
                          <p className="opportunity-card-text">
                            Remarks: {data.Remarks}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>No meeting records found.</div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
 
export default BusinessMeetingsHotel;